import React from 'react';
import {RegisterForm} from "../../components/forms";
import {Link, PageAnimator, StripeBG} from "../../components";
import * as Paths from '../../constants/Paths'
import { navigateTo } from "gatsby-link"
import {seoPageChange} from '../../utils'

class RegisterPage extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {seoPageChange()}

  render() {
    return (
      <div className="RegisterPage grid-row grid-column v-align h-align full-height">
        <StripeBG />
        <PageAnimator>
          <div className="form form-page">
            <div className="f1 t-center f-strong f-subdued s8">New Account</div>
            <div className="login-form s6">
              <RegisterForm onSuccess={(user) => navigateTo(Paths.DB_USER_HOME) }/>
            </div>
            <div className="s1">
              <Link href={"/account/login"} className="f4">
                <span className="pt-icon-standard pt-icon-arrow-left" />Back to login
              </Link>
            </div>
          </div>
        </PageAnimator>
      </div>
    );
  }
}

export default RegisterPage;


// WEBPACK FOOTER //
// ./src/pages/account/register.js